(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gz-purchase"] && !Shopify.designMode) return;
  try {
    function initGeezersPurchase(root=document){root.querySelectorAll('[data-gz-purchase]').forEach(box=>{if(box.dataset.initialized)return;box.dataset.initialized='true';const update=()=>{const subscription=box.querySelector('input[name="selling_plan"]:checked')?.dataset.purchaseMode==='subscription';const ready=box.dataset.ready==='true';const validPlan=Boolean(box.dataset.plan);const canBuy=ready&&(!subscription||validPlan);box.querySelector('[data-purchase-submit]').hidden=!canBuy;box.querySelector('[data-purchase-notify]').hidden=canBuy;box.querySelector('[data-purchase-status]').textContent=canBuy?box.dataset.checkoutNote:ready?box.dataset.subscriptionNote:box.dataset.launchNote};box.addEventListener('change',update);update()})}
  initGeezersPurchase();document.addEventListener('shopify:section:load',event=>initGeezersPurchase(event.target));
  } catch(e) { console.error(e); }
})();

})();
